<template>
  <div class="questionnaire-item">
    <div
      v-for="category in data.categories" :key="category.id"
      class="questionnaire-item-category">
      <div class="questionnaire-item-category-title">{{category.title}}</div>

      <QuestionnaireQuestion
        v-for="question in category.questions" :key="question.id"
        :question="question"
        v-on:update-fields="updateFields" />
    </div>

    <div class="button" @click="submit">Отправить анкету</div>
  </div>
</template>

<script>
  import QuestionnaireQuestion from './Question';

  export default {
    name: 'QuestionnaireItem',

    components: {QuestionnaireQuestion},

    props: ['questionnaire', 'user'],

    data() {
      return {
        answers: {},
      };
    },

    computed: {
      data() {
        const data = {
          id: this.questionnaire.id,
          title: this.questionnaire.title,
          categories: [],
        };

        for (const category of this.questionnaire.categories) {
          const { id, title, description, sort } = category;
          const questions = [];

          for (const question of category.questions) {
            const { id, text, type, multiple, sort, gender } = question;
            const answers = this.answers[id] || [];
            const fields = [];

            if (gender === 'male' && this.user.gender !== 'm') {
              continue;
            }

            if (gender === 'female' && this.user.gender !== 'f') {
              continue;
            }

            for (const field of question.fields) {
              const { id, label, type, note, sort } = field;
              const inSelected = answers.find(i => i.field === id);
              const selected = typeof inSelected !== 'undefined';

              fields.push({ id, label, type, note, sort, selected });
            }

            questions.push({ id, text, type, multiple, sort, fields, answers });
          }

          data.categories.push({ id, title, description, sort, questions });
        }


        data.categories.sort((a, b) => a.sort - b.sort);

        data.categories.forEach(category => {
          category.questions.sort((a, b) => a.sort - b.sort);

          category.questions.forEach(question => {
            question.fields.sort((a, b) => a.sort - b.sort);
          });
        });

        return data;
      },
    },

    methods: {
      updateFields(data) {
        const { questionId, fields } = data;

        this.answers[questionId] = fields;

        this.answers = Object.assign({}, this.answers);
      },

      async submit() {
        const data = { id: this.questionnaire.id, answers: [] };

        for (const questionId of Object.keys(this.answers)) {
          for (const { field, value } of this.answers[questionId]) {
            data.answers.push({ field, value });
          }
        }

        this.$emit('submit-questionnaire', data)
      },
    },
  }
</script>

<style lang="scss">
  @import "../../assets/scss/variables.scss";

  .questionnaire-item {
    padding-bottom: 30px;

    .questionnaire-item-category {
      .questionnaire-item-category-title {
        padding: 10px 0 10px 20px;
        font-size: 12px;
        font-weight: bold;
        text-transform: uppercase;
        color: $white;
        background-color: $primary;
      }
    }

    .button {
      display: block;
      width: 80%;
      margin: 30px auto 10px;
      padding: 10px 10px;
      background-color: $primary;
      border-radius: 20px;
      text-align: center;
    }
  }
</style>
